import React from 'react';

import { DataDisputeReportInfoFragment } from 'src/api';
import { TableColumn } from 'src/components/table';
import { useReportItemsFilter } from 'src/hooks/reports';
import { useCurrentUser } from 'src/hooks/user';

import { getDataDisputeReportTableColumnsEmployerStaff } from '../utils';

import { DataDisputeReportInnerTable } from './DataDisputeReportInnerTable';

export const DataDisputeReportTableEmployerAdmin: React.FC = () => {
  const { timezone } = useCurrentUser();
  const { filter } = useReportItemsFilter();

  const columns = React.useMemo<Array<TableColumn<DataDisputeReportInfoFragment>>>(
    () => getDataDisputeReportTableColumnsEmployerStaff(timezone),
    [timezone],
  );

  return <DataDisputeReportInnerTable columns={columns} filter={filter} />;
};
